import { getStorage } from './../../Auth/config';

export const getRemoteDesktopFile = (fileName = 'test.txt') => {
    return getStorage().get(fileName, { download: true });
}